import {Link, withRouter} from 'react-router-dom'
import Popup from 'reactjs-popup'
import Cookies from 'js-cookie'

import {FaMoon} from 'react-icons/fa'
import {FiSun, FiLogOut} from 'react-icons/fi'
import {GiHamburgerMenu} from 'react-icons/gi'
import {IoMdClose} from 'react-icons/io'

import AppContext from '../../context/AppContext'
import {
  HeaderContainer,
  WebsiteLogo,
  ThemeImg,
  LogoutButton,
  NavElements,
  ProfileImg,
  CardHeading,
  PopupEl,
  PopupButton,
  Icon,
  DThemeImg,
} from './styledComponents'
import './index.css'

const Header = props => {
  const onClickLogout = close => {
    const {history} = props
    Cookies.remove('jwt_token')
    close()
    history.replace('/login')
  }
  return (
    <AppContext.Consumer>
      {value => {
        const {theme, onClickChangeTheme, onClickUpdateSideBar} = value

        const changeTheme = () => {
          onClickChangeTheme()
        }

        const onClickSidebar = () => {
          onClickUpdateSideBar()
        }

        return (
          <HeaderContainer theme={theme}>
            <Link to="/">
              <WebsiteLogo
                theme={theme}
                src={
                  theme
                    ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'
                    : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'
                }
                alt="website logo"
              />
            </Link>
            <NavElements>
              <ThemeImg theme={theme} data-testid="theme" onClick={changeTheme}>
                {theme ? (
                  <Icon theme={theme} as={FiSun} />
                ) : (
                  <Icon theme={theme} as={FaMoon} />
                )}
              </ThemeImg>
              <ThemeImg>
                <ProfileImg
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-profile-img.png"
                  alt="profile"
                />
              </ThemeImg>
              <DThemeImg theme={theme}>
                <Icon
                  theme={theme}
                  as={GiHamburgerMenu}
                  onClick={onClickSidebar}
                />
              </DThemeImg>
              <div className="large-devices-popup">
                <Popup
                  modal
                  trigger={
                    <LogoutButton type="button" theme={theme}>
                      Logout
                    </LogoutButton>
                  }
                  className="popup-content"
                >
                  {close => (
                    <>
                      <button type="button" onClick={() => close()}>
                        <IoMdClose className="closeIcon" />
                      </button>
                      <div className="popup-content">
                        <PopupEl theme={theme}>
                          <CardHeading theme={theme} className="popup-heading">
                            Are you sure, you want to logout
                          </CardHeading>
                          <div className="popup-buttons">
                            <PopupButton
                              theme={theme}
                              outline
                              type="button"
                              onClick={() => close()}
                            >
                              Cancel
                            </PopupButton>
                            <PopupButton
                              theme={theme}
                              type="button"
                              className="confirm"
                              onClick={() => onClickLogout(close)}
                            >
                              Confirm
                            </PopupButton>
                          </div>
                        </PopupEl>
                      </div>
                    </>
                  )}
                </Popup>
              </div>
              <div className="small-devices-popup">
                <Popup
                  modal
                  trigger={
                    <DThemeImg theme={theme}>
                      <Icon theme={theme} as={FiLogOut} />
                    </DThemeImg>
                  }
                  className="popup-content"
                >
                  {close => (
                    <>
                      <button type="button" onClick={() => close()}>
                        <IoMdClose className="closeIcon" />
                      </button>
                      <div className="popup-content">
                        <PopupEl theme={theme}>
                          <CardHeading theme={theme} className="popup-heading">
                            Are you sure, you want to logout
                          </CardHeading>
                          <div className="popup-buttons">
                            <PopupButton
                              theme={theme}
                              outline
                              type="button"
                              onClick={() => close()}
                            >
                              Cancel
                            </PopupButton>
                            <PopupButton
                              theme={theme}
                              type="button"
                              className="confirm"
                              onClick={() => onClickLogout(close)}
                            >
                              Confirm
                            </PopupButton>
                          </div>
                        </PopupEl>
                      </div>
                    </>
                  )}
                </Popup>
              </div>
            </NavElements>
          </HeaderContainer>
        )
      }}
    </AppContext.Consumer>
  )
}

export default withRouter(Header)
